"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowIdServiceNS = void 0;
var FlowIdServiceNS;
(function (FlowIdServiceNS) {
    FlowIdServiceNS.FLOW_ID_SERVICE_ID = Symbol.for("FlowIdService");
})(FlowIdServiceNS = exports.FlowIdServiceNS || (exports.FlowIdServiceNS = {}));
//# sourceMappingURL=flow-id.types.js.map